module.exports = __webpack_public_path__ + "img/hr-rock-big-05.44004e4f.png";